import React, {FormEvent, useRef, useState} from "react";
import Input from "@/components/ContentElements/Forms/Fields/Input";
import Text from "@/components/typographie/Text/Text";
import clsx from "clsx";
import {useTranslations} from "next-intl";
import {sendAzureMail} from "@/libs/mailing/AzureMail";

export interface FormProps {
    children?: React.ReactNode
    className?: string
    setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>
}

export default function NewsletterForm({children, className, setIsSubmitting}:FormProps) {
    const [message, setMessage] = useState({status: 0, text: ''})
    const t = useTranslations("Forms")
    const ref = useRef<HTMLFormElement>(null)

    async function onSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        setMessage({status: 0, text: ''})
        setIsSubmitting(true)

        const formData = new FormData(event.currentTarget)
        const formValues = Object.fromEntries(formData.entries())

        let hostname = '';
        if (typeof window !== 'undefined') {
            hostname = window.location.hostname;
        }

        try {
            const EmailData = {
                to: "corporate@bonprix.net" ,
                cc: 'andre.koch@hmmh.de',
                from: "corporate@bonprix.net",
                subject: t("NewsletterForm.subject"),
                // language=HTML
                html: `
            <p>Vorname: ${formValues.first_name} </p>
            <p>Nachname: ${formValues.last_name} </p>
            <p>E-Mail: ${formValues.email} </p>
            <p>Verlag: ${formValues.publisher_editorial} </p>
            <p>News Type: ${formValues.newsletter} </p>
            <p>Gesendet vom Host: ${hostname} </p>
            `,
            }

            const sendingResponse = await sendAzureMail(EmailData)
            setIsSubmitting(false)
            if(sendingResponse){
                setMessage({status: 200, text: t("NewsletterForm.Mailing.success")})
            } else {
                setMessage({status: 500, text: t("NewsletterForm.Mailing.error")})
            }

        } catch (err) {
            console.error(err)
        } finally {
            ref.current?.reset()
            setIsSubmitting(false)
        }
    }


    return (
        <>
            <form onSubmit={onSubmit}
                  ref={ref} className={className}>
                {message.text && <p className={clsx(message.status === 200 ? "text-success" : "text-error", 'text-h2 font-sans')}>{message.text}</p>}
                <fieldset className="flex flex-wrap gap-l md:gap-xl">
                    <legend className="w-full mb-s"><Text>{t("NewsletterForm.interests")}</Text></legend>
                    <Input label={t("NewsletterForm.allNews")} type="radio" name="newsletter" value="all_news" isRequired={true} checked={true}/>
                    <Input label="Corporate News" type="radio" name="newsletter" value="corporate_news" isRequired={true}/>
                    <Input label="Fashion News" type="radio" name="newsletter" value="fashion_news" isRequired={true}/>
                </fieldset>
                <Input label={t("Labels.firstName")} type="text" palceholder={t("Placeholder.yourFirstName")} name="first_name" isRequired={true}/>
                <Input label={t("Labels.lastName")} type="text" palceholder={t("Placeholder.yourLastName")} name="last_name" isRequired={true}/>
                <Input label={t("Labels.employer")} type="text" palceholder={t("Placeholder.yourEmployer")} name="publisher_editorial"
                       isRequired={true}/>
                <Input label={t("Labels.email")} type="email" palceholder={t("Placeholder.emailAdress")} name="email" isRequired={true}/>
                {children}
            </form>
        </>
    )
}